import { CircularProgress } from '@mui/material';
import React from 'react';
import { useConsumeWeaveTheme } from '../../hocs/ApplicationWrapper/theme/WeaveContext';
import ProgressRing from '@weave-design/progress-ring';
import styled from 'styled-components';
const ProgressRingWrapper = styled.div `
	display: flex;
	width: 20px;
`;
export const MiniLoading = ({ loading, children, dataCy, }) => {
    const { isWeaveTheme } = useConsumeWeaveTheme();
    if (loading) {
        return (React.createElement("div", { "data-testing-id": 'mini-loading', "data-cy": dataCy }, isWeaveTheme ? (React.createElement(ProgressRingWrapper, { style: { display: 'flex', width: 20 } },
            React.createElement(ProgressRing, { size: "s" }))) : (React.createElement(CircularProgress, { color: "inherit", size: 20, style: { display: 'flex' } }))));
    }
    return React.createElement(React.Fragment, null, children);
};
export default MiniLoading;
